export default __webpack_public_path__ + "static/media/penetratingshot4.9d08794a.png";